export const clientPortal: Record<string, string> = {
  // ── Shell ────────────────────────────────────────────────────────────────
  'Failed to load client portal': 'Impossible de charger le portail client',
  'Client portal unavailable': 'Portail client indisponible',
  'Your account could not be loaded.': 'Votre compte n’a pas pu être chargé.',
  'Sign out': 'Se déconnecter',
  'Client Portal': 'Portail client',
  'Client account': 'Compte client',
  'Primary contact': 'Contact principal',
  'Not set': 'Non renseigné',
  'Posts': 'Postes',
  'Client portal navigation': 'Navigation du portail client',
  'Secured by {company}': 'Sécurisé par {company}',
  'All sites ({count})': 'Tous les sites ({count})',
  'Portal user': 'Utilisateur du portail',
  '1 of {count} sites': '1 site sur {count}',

  // Navigation labels and summaries (referenced dynamically).
  'Overview': 'Aperçu',
  'Today at a glance': 'La journée en un coup d’œil',
  'Live Operations': 'Opérations en direct',
  'Officers on duty right now': 'Agents actuellement en service',
  'Incidents, daily logs and visitor records':
    'Incidents, rapports quotidiens et registres de visiteurs',
  'Guard Tours': 'Rondes de sécurité',
  'Patrol sweeps and checkpoint history': 'Rondes et historique des points de contrôle',
  'Post Orders': 'Consignes de poste',
  'Site rules and emergency procedures': 'Règles du site et procédures d’urgence',
  'Coverage calendar and cover requests':
    'Calendrier de couverture et demandes de renfort',
  'Portal Users': 'Utilisateurs du portail',
  'Who on your team can see what': 'Qui, dans votre équipe, voit quoi',

  // ── Overview ─────────────────────────────────────────────────────────────
  'Officers on duty': 'Agents en service',
  'Across {count} sites': 'Sur {count} sites',
  'Not enabled on your account': 'Non activé sur votre compte',
  'Patrols completed': 'Rondes terminées',
  'Last 24 hours': 'Dernières 24 heures',
  'Missed sweeps': 'Rondes manquées',
  'Open incidents': 'Incidents ouverts',
  'Awaiting closure': 'En attente de clôture',
  'On duty now': 'En service actuellement',
  'Officers currently clocked in at your property.':
    'Agents actuellement pointés sur votre site.',
  'Your security provider has not enabled on-duty visibility.':
    'Votre prestataire de sécurité n’a pas activé la visibilité des agents en service.',
  'No officers are clocked in right now.': 'Aucun agent n’est pointé pour le moment.',
  'Officer on duty': 'Agent en service',
  'On duty': 'En service',
  'Since {time}': 'Depuis {time}',
  'Latest reports': 'Derniers rapports',
  'The most recent submissions released to you.':
    'Les dernières soumissions qui vous ont été communiquées.',
  'All reports': 'Tous les rapports',
  'No reports have been released to your portal yet.':
    'Aucun rapport n’a encore été communiqué à votre portail.',
  'Recent patrol activity': 'Activité de ronde récente',
  'Sweeps recorded across your sites in the last 24 hours.':
    'Rondes enregistrées sur vos sites au cours des dernières 24 heures.',
  'Tour records': 'Historique des rondes',
  'Your security provider has not enabled patrol visibility.':
    'Votre prestataire de sécurité n’a pas activé la visibilité des rondes.',
  'No patrols were scheduled in the last 24 hours.':
    'Aucune ronde n’était planifiée au cours des dernières 24 heures.',
  'Missed': 'Manquée',
  'In progress': 'En cours',
  '{done}/{total} checkpoints': '{done}/{total} points de contrôle',

  // ── Live operations ──────────────────────────────────────────────────────
  'No live positions are being reported right now.':
    'Aucune position en direct n’est transmise pour le moment.',
  'Live GPS tracking is switched off': 'Le suivi GPS en direct est désactivé',
  'Your security provider controls live tracking for this contract. Contact them if you need map visibility.':
    'Votre prestataire de sécurité contrôle le suivi en direct pour ce contrat. Contactez-le si vous avez besoin d’une visibilité cartographique.',
  'Last ping {time}': 'Dernier signal {time}',
  'Everyone currently clocked in at your sites.':
    'Toutes les personnes actuellement pointées sur vos sites.',
  '{duration} on site': '{duration} sur site',
  'Show on map': 'Voir sur la carte',
  'Patrols in progress': 'Rondes en cours',
  'Checkpoints hit as officers work through a tour.':
    'Points de contrôle validés au fil de la ronde.',
  'No patrol is running at the moment.': 'Aucune ronde n’est en cours pour le moment.',
  '{done} of {total} checkpoints complete':
    '{done} points de contrôle sur {total} validés',
  'Started {time}': 'Débutée {time}',
  'Showing every site on your contract. Use the site selector to narrow this view.':
    'Affichage de tous les sites de votre contrat. Utilisez le sélecteur de site pour affiner cette vue.',

  // ── Reports ──────────────────────────────────────────────────────────────
  'No report feeds are enabled': 'Aucun flux de rapports n’est activé',
  'Your security provider controls which reports reach this portal.':
    'Votre prestataire de sécurité détermine quels rapports parviennent à ce portail.',
  'Daily Activity': 'Activité quotidienne',
  'Visitor & Vehicle Logs': 'Registres visiteurs et véhicules',
  'Patrol Reports': 'Rapports de ronde',
  'Search reports': 'Rechercher des rapports',
  'From': 'Du',
  'To': 'Au',
  'History limited to {count} days': 'Historique limité à {count} jours',
  'No reports match this view.': 'Aucun rapport ne correspond à cette vue.',
  'Report detail': 'Détail du rapport',
  'Close report': 'Fermer le rapport',
  'Download Word': 'Télécharger le document Word',
  'Report attachment': 'Pièce jointe du rapport',
  'Released to your portal on {date}': 'Communiqué à votre portail le {date}',

  // ── Guard tours ──────────────────────────────────────────────────────────
  'Patrol records are not enabled': 'Les historiques de ronde ne sont pas activés',
  'Last 7 days': '7 derniers jours',
  'Last 30 days': '30 derniers jours',
  'Sweeps scheduled': 'Rondes planifiées',
  'Started late': 'Démarrées en retard',
  'No patrol sweeps were recorded in this period.':
    'Aucune ronde n’a été enregistrée sur cette période.',
  'Skipped': 'Ignorée',
  'Scheduled': 'Planifiée',
  'Actual': 'Réel',
  'Not started': 'Non démarrée',
  'ongoing': 'en cours',
  'No checkpoint scans were recorded for this sweep.':
    'Aucun scan de point de contrôle n’a été enregistré pour cette ronde.',
  'Outside geofence': 'Hors périmètre',

  // ── Post orders ──────────────────────────────────────────────────────────
  'No post orders published yet': 'Aucune consigne de poste publiée',
  'Your security provider publishes the agreed site rules and procedures here.':
    'Votre prestataire de sécurité publie ici les règles et procédures convenues pour le site.',
  'General': 'Général',
  'Emergency procedures': 'Procédures d’urgence',
  'Escalation': 'Escalade',
  'Access control': 'Contrôle d’accès',
  '{count} published directives': '{count} consignes publiées',
  'Version {version}': 'Version {version}',
  'Effective {date}': 'En vigueur le {date}',
  'Updated {date}': 'Mis à jour le {date}',

  // ── Schedule and requests ────────────────────────────────────────────────
  'Published duties confirming the cover booked for your sites.':
    'Services publiés confirmant la couverture réservée pour vos sites.',
  'Previous week': 'Semaine précédente',
  'Next week': 'Semaine suivante',
  'No cover booked': 'Aucune couverture réservée',
  '{assigned}/{required} booked': '{assigned}/{required} réservés',
  'Cover requests': 'Demandes de renfort',
  'Ask for extra hours, emergency dispatch or event coverage.':
    'Demandez des heures supplémentaires, une intervention d’urgence ou une couverture d’événement.',
  'New request': 'Nouvelle demande',
  'What do you need?': 'De quoi avez-vous besoin ?',
  'e.g. Extra officer for contractor access':
    'ex. Agent supplémentaire pour l’accès des prestataires',
  'Request type': 'Type de demande',
  'Extra guard hours': 'Heures d’agent supplémentaires',
  'Emergency dispatch': 'Intervention d’urgence',
  'Event coverage': 'Couverture d’événement',
  'Supervisor site visit': 'Visite d’un superviseur',
  'Something else': 'Autre chose',
  'Urgency': 'Urgence',
  'Routine': 'Courante',
  'Urgent': 'Urgente',
  'Emergency': 'Urgence',
  'Not site specific': 'Non spécifique à un site',
  'Officers needed': 'Agents nécessaires',
  'Extra detail': 'Détails complémentaires',
  'Access arrangements, contacts, anything the officer should know.':
    'Modalités d’accès, contacts, tout ce que l’agent doit savoir.',
  'Send request': 'Envoyer la demande',
  'Please describe what you need.': 'Veuillez décrire ce dont vous avez besoin.',
  'Request sent to your security provider.':
    'Demande envoyée à votre prestataire de sécurité.',
  'You have not raised any cover requests yet.':
    'Vous n’avez encore soumis aucune demande de renfort.',
  'Request': 'Demande',
  '{count} officers': '{count} agents',
  'Provider response': 'Réponse du prestataire',
  'Acknowledged': 'Prise en compte',
  'Declined': 'Refusée',
  'Withdraw': 'Retirer',
  'Scheduling is not enabled': 'La planification n’est pas activée',
  'Your security provider controls which sections reach this portal.':
    'Votre prestataire de sécurité détermine quelles sections parviennent à ce portail.',
  'Only published duties appear here. Draft rosters stay hidden until your provider publishes them.':
    'Seuls les services publiés apparaissent ici. Les plannings provisoires restent masqués jusqu’à leur publication par votre prestataire.',

  // ── Portal users (client side) ───────────────────────────────────────────
  'Portal users': 'Utilisateurs du portail',
  'Give colleagues their own sign-in with only the access they need.':
    'Offrez à vos collègues leur propre accès, limité à ce dont ils ont besoin.',
  'Invite user': 'Inviter un utilisateur',
  'Job title': 'Fonction',
  'e.g. Front desk manager': 'ex. Responsable de l’accueil',
  'What can they see?': 'Que peuvent-ils voir ?',
  'Start from': 'Partir de',
  'Property manager': 'Gestionnaire immobilier',
  'Front desk': 'Accueil',
  'Security lead': 'Responsable sûreté',
  'Which sites?': 'Quels sites ?',
  'All sites on the contract': 'Tous les sites du contrat',
  'Invite created for {email}.': 'Invitation créée pour {email}.',
  'Share this link if the email does not arrive:':
    'Partagez ce lien si l’e-mail n’arrive pas :',
  'Copy': 'Copier',
  'Link copied.': 'Lien copié.',
  'Full access as the primary contact.': 'Accès complet en tant que contact principal.',
  'No sections granted yet.': 'Aucune section accordée pour l’instant.',
  '{count} of {total} sites': '{count} sites sur {total}',
  'Invite cancelled.': 'Invitation annulée.',
  'Last seen {time}': 'Dernière connexion {time}',
  'Change access': 'Modifier les accès',
  'Done': 'Terminé',
  'Revoke': 'Révoquer',
  'Restore': 'Rétablir',
  'Access updated.': 'Accès mis à jour.',
  'Access revoked.': 'Accès révoqué.',
  'Access restored.': 'Accès rétabli.',

  // Grantable scopes (referenced dynamically).
  'Live GPS map': 'Carte GPS en direct',
  'See officer positions in real time': 'Voir la position des agents en temps réel',
  'On-duty officers': 'Agents en service',
  'Who is clocked in right now': 'Qui est pointé en ce moment',
  'Live patrol progress': 'Avancement des rondes en direct',
  'Checkpoints as they are hit': 'Les points de contrôle au fur et à mesure',
  'Incident reports': 'Rapports d’incident',
  'Incident submissions and photos': 'Déclarations d’incident et photos',
  'Daily activity reports': 'Rapports d’activité quotidiens',
  'Shift summaries and observations': 'Synthèses de vacation et observations',
  'Patrol records': 'Historiques de ronde',
  'Historical tour completion': 'Historique d’exécution des rondes',
  'Visitor & vehicle logs': 'Registres visiteurs et véhicules',
  'Access control records': 'Enregistrements de contrôle d’accès',
  'Post orders': 'Consignes de poste',
  'Site rules and procedures': 'Règles et procédures du site',
  'Coverage calendar': 'Calendrier de couverture',
  'Booked shifts for your sites': 'Vacations réservées pour vos sites',
  'Raise and track extra cover': 'Soumettre et suivre les renforts',
  'Downloads': 'Téléchargements',
  'Export reports to PDF and Word': 'Exporter les rapports en PDF et Word',

  // ── Agency-side portal controls ──────────────────────────────────────────
  'Portal visibility': 'Visibilité du portail',
  'Portal visibility for {name}': 'Visibilité du portail pour {name}',
  'Client portal control': 'Contrôle du portail client',
  'Decide exactly what this client can see. Changes apply immediately.':
    'Décidez précisément ce que ce client peut voir. Les modifications s’appliquent immédiatement.',
  'Saved': 'Enregistré',
  'Operations & real-time monitoring': 'Opérations et supervision en temps réel',
  'What the client can see while officers are on shift.':
    'Ce que le client peut voir pendant que les agents sont en service.',
  'Real-time officer positions. Off by default — enable only where the client has agreed.':
    'Position des agents en temps réel. Désactivé par défaut — à n’activer qu’avec l’accord du client.',
  'On-duty officer list': 'Liste des agents en service',
  'Names and shift times of officers currently clocked in.':
    'Noms et horaires des agents actuellement pointés.',
  'Checkpoint scans as a tour is walked.':
    'Scans des points de contrôle au fil de la ronde.',
  'Reports & accountability': 'Rapports et traçabilité',
  'Which feeds reach the portal, and how soon.':
    'Quels flux parviennent au portail, et à quel moment.',
  'Severity, description, time and location stamps, media.':
    'Gravité, description, horodatage et localisation, médias.',
  'Shift summaries and routine field observations.':
    'Synthèses de vacation et observations de terrain courantes.',
  'Guard tour records': 'Historiques de ronde',
  'Completed, delayed and missed patrol sweeps.':
    'Rondes terminées, retardées et manquées.',
  'Access control records captured at entry points.':
    'Enregistrements de contrôle d’accès relevés aux points d’entrée.',
  'PDF and Word exports': 'Exports PDF et Word',
  'Let the client download audit-ready copies.':
    'Permettre au client de télécharger des copies prêtes pour l’audit.',
  'Site context & scheduling': 'Contexte du site et planification',
  'Directives, coverage and requests.': 'Consignes, couverture et demandes.',
  'Published site rules, duties and emergency procedures.':
    'Règles du site, missions et procédures d’urgence publiées.',
  'Published duties confirming booked cover.':
    'Services publiés confirmant la couverture réservée.',
  'On-demand requests': 'Demandes à la demande',
  'Let the client request extra hours or emergency dispatch.':
    'Permettre au client de demander des heures supplémentaires ou une intervention d’urgence.',
  'Sub-accounts': 'Sous-comptes',
  'Let the primary contact create limited logins for colleagues.':
    'Permettre au contact principal de créer des accès limités pour ses collègues.',
  'Report approval rules': 'Règles de validation des rapports',
  'Choose whether submissions publish on the spot or wait for supervisor review.':
    'Choisissez si les soumissions sont publiées immédiatement ou après validation d’un superviseur.',
  'Incident report release': 'Diffusion des rapports d’incident',
  'Routine report release': 'Diffusion des rapports courants',
  'On submission': 'À la soumission',
  'After review': 'Après validation',
  'Incidents appear in the portal the moment a guard submits them.':
    'Les incidents apparaissent dans le portail dès qu’un agent les soumet.',
  'Incidents stay hidden until a supervisor releases them from the report screen.':
    'Les incidents restent masqués jusqu’à ce qu’un superviseur les diffuse depuis l’écran du rapport.',
  'Daily, patrol and visitor reports': 'Rapports quotidiens, de ronde et de visiteurs',
  'Applies to routine paperwork submitted from the field app.':
    'S’applique aux documents courants soumis depuis l’application de terrain.',
  'Officer identity': 'Identité de l’agent',
  'How much of an on-duty officer the client sees.':
    'Ce que le client voit d’un agent en service.',
  'Name and phone': 'Nom et téléphone',
  'The client can call the officer directly.':
    'Le client peut appeler l’agent directement.',
  'Name only': 'Nom uniquement',
  'Identifies the officer without exposing contact details.':
    'Identifie l’agent sans divulguer ses coordonnées.',
  'Anonymised': 'Anonymisé',
  'Shows that a post is covered without naming who.':
    'Indique qu’un poste est couvert sans nommer l’agent.',
  'History window': 'Fenêtre d’historique',
  'How far back the portal may read. Leave empty for the full contract history.':
    'Jusqu’où le portail peut remonter. Laissez vide pour tout l’historique du contrat.',
  'Unlimited': 'Illimité',
  'days': 'jours',
  'Portal accounts': 'Comptes du portail',
  'Who at this client can sign in, and what the primary contact has granted them.':
    'Qui, chez ce client, peut se connecter, et ce que le contact principal lui a accordé.',
  'No portal accounts have been activated yet.':
    'Aucun compte de portail n’a encore été activé.',
  'Sub-account': 'Sous-compte',
  'No sections granted': 'Aucune section accordée',
  '{count} sections': '{count} sections',
  'Sub-account permissions are set by the client’s primary contact, but never exceed what you enable above.':
    'Les autorisations des sous-comptes sont définies par le contact principal du client, sans jamais dépasser ce que vous activez ci-dessus.',

  // ── Report release (agency report screen) ────────────────────────────────
  'Client portal': 'Portail client',
  'Visible to the client since {date}': 'Visible par le client depuis le {date}',
  'Not released to the client': 'Non communiqué au client',
  'Release to client': 'Communiquer au client',
  'Withhold from client': 'Retirer au client',

  // ── Relative time ────────────────────────────────────────────────────────
  'Never': 'Jamais',
  'Just now': 'À l’instant',
  '{count} min ago': 'il y a {count} min',
  '{count} h ago': 'il y a {count} h',
  '{count} d ago': 'il y a {count} j',
  '{hours}h {minutes}m': '{hours} h {minutes} min',
  '{count} min late': '{count} min de retard',
  '{count} h late': '{count} h de retard',

  // ── Report priorities (referenced dynamically) ───────────────────────────
  'low': 'faible',
  'medium': 'moyenne',
  'high': 'élevée',
  'critical': 'critique',
  // ── Agency: cover request queue ──────────────────────────────────────────
  'Client cover requests': 'Demandes de renfort des clients',
  'Extra hours, emergency dispatch and event coverage raised from client portals.':
    'Heures supplémentaires, interventions d’urgence et couvertures d’événement soumises depuis les portails clients.',
  'Include closed requests': 'Inclure les demandes clôturées',
  '{count} urgent requests are waiting for a response.':
    '{count} demandes urgentes attendent une réponse.',
  'No open requests': 'Aucune demande ouverte',
  'Requests raised by clients in their portal land here.':
    'Les demandes soumises par les clients depuis leur portail arrivent ici.',
  'Your response': 'Votre réponse',
  'Message shown to the client': 'Message affiché au client',
  'Send response': 'Envoyer la réponse',
  'Response sent to the client.': 'Réponse envoyée au client.',

  // ── Agency: post order authoring ─────────────────────────────────────────
  'Post orders for {name}': 'Consignes de poste pour {name}',
  'The rules, duties and procedures guards follow here. Client-visible entries appear in the client portal.':
    'Les règles, missions et procédures que les agents suivent ici. Les entrées visibles par le client apparaissent dans le portail client.',
  'New post order': 'Nouvelle consigne de poste',
  'No post orders yet for this site.': 'Aucune consigne de poste pour ce site.',
  'Category': 'Catégorie',
  'Order': 'Ordre',
  'Title': 'Titre',
  'e.g. Fire alarm activation': 'ex. Déclenchement d’alarme incendie',
  'Instructions': 'Consignes',
  'Step-by-step detail the officer should follow.':
    'Le détail, étape par étape, que l’agent doit suivre.',
  'Visible in the client portal': 'Visible dans le portail client',
  'Uncheck to keep this directive internal to your officers.':
    'Décochez pour réserver cette consigne à vos agents.',
  'Save post order': 'Enregistrer la consigne',
  'A post order needs a title and a body.':
    'Une consigne de poste doit comporter un titre et un contenu.',
  'Internal only': 'Interne uniquement',
  'Hide from client portal': 'Masquer dans le portail client',
  'Show in client portal': 'Afficher dans le portail client',
};
